import React from 'react';

const Testimonials = () => {
    return (
        <div>
            
        </div>
    );
};

export default Testimonials;